import { useState, useEffect, useRef } from 'react'
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Papa from 'papaparse';

import { api } from "./pureFunctions";
import { Spinner } from 'react-bootstrap';

const host = import.meta.env.PROD ? "" : "http://localhost:8080"


function IMVImport({ user}) {
  const [users, setUsers] = useState()
  const [selecteduser, setSelectedUser]=useState(()=>user&&user.Name/* localStorage.getItem("user")&&JSON.parse(localStorage.getItem("user")).Name */)
  const [imvdata, setIMVData] = useState()
  const [imvheader, setIMVHeader] = useState()
  const [file, setFile] = useState()
  const [importstate, setImportstate] = useState("loading")

  useEffect(() => {
    file && Papa.parse(file, {
      complete: function (results) {
        setIMVData(results.data.slice(1, -1))
        setIMVHeader(results.data.slice(0, 1))
        console.log("Finished:", results.data);

      }
    })
  }, [file])

  useEffect(() => {
    api.get('/api/getusers').then((data) => {
      const cleanUserData = data.data.data.filter((user) => user.elements.Nachname&&!(user.elements.Name==="Frank"))
      console.log(data);
      
      setUsers(cleanUserData)

    })
  }, [])

  const postIMVData = (data, selecteduser) => {
    setImportstate("loading")

    data && api.post( '/api/postimvdata', {data: data, user: selecteduser}, { 'Content-type': 'application/json', 'Accept': 'text/plain' }).then((resp_data) => {
      setImportstate((resp_data.data === "data success") ? "success" : "error")
      console.log(resp_data);

      return (resp_data.data)
    }).catch((err)=>{
      setImportstate("error")
    })
  }

  useEffect(() => {
    if (users && imvdata) {
      setImportstate("")
    }
  }, [users, imvdata])


  const rows = imvdata && imvdata.map((row, rowindex) => (
    <tr key={"imvrow" + rowindex}>
      {row.map((column, colindex) => <td key={"imvtable" + rowindex + "_" + colindex}>{column}</td>)}
    </tr>
  ));


  return (
    <div className='pt-3 ps-5 pe-5'>
<div className=''>
  <title>IMV Import</title>
<h1>IMV Import</h1>
  <a target="_blank" className="btn btn-outline-primary me-2" rel="noopener noreferrer" href="https://www.imv-online.de/imvonline_suche.php">↗ IMV-Suche</a>
  <a target="_blank" className="btn btn-outline-primary" rel="noopener noreferrer" href="https://smart.onoffice.de/smart/smart.php?params=PtBPjKSW%2BmZii5ofCvGqppqF7LVFygqtTvSwFNLZIltGRNIQO%2F%2BpirbeSqECaG7mqUfU6OzRGpXctN7AFdnTkPvIdKy%2FLzy39ks6YbLazCrbq1DjGP3dI%2FCASvlnGEzG">↗ onOffice</a>
  </div>

      <div className="table-responsive rounded-4 mt-3" style={{ width: "95vw" }}>
        <table className="table table-dark table-hover mb-0">
          <thead>
            <tr>
              {imvheader && imvheader[0].map((element, index) => <th key={"imvtablehead" + index}>{element}</th>)}
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>


      <div className="mb-3 mt-3">
      


        <label forhtml="formFile" className="form-label">IMV-Exportdatei</label>
        <input className="form-control" type="file" id="formFile" onChange={e => setFile(e.target.files[0])} accept=".csv" />


        <Form>
      <Row className="mb-3 mt-3">
        <Form.Group as={Col} controlId="formGridState">
          <Form.Label>Betreuer auswählen</Form.Label>
          <Form.Select  value={selecteduser} onChange={e=>setSelectedUser(e.target.value)}>
          <option value="" key={"user X"}></option>
          {users && users.map((user, index) => { return (<option value={user.elements.Name} key={user + index}>{user.elements.Nachname + " " + user.elements.Vorname}</option>) })}
          </Form.Select>

        </Form.Group>
      </Row></Form>
      </div>
      {(importstate === "success") && <div className="alert alert-success" role="alert">
        Import erfolgreich!
      </div>}
      {(importstate === "error") && <div className="alert alert-danger" role="alert">
        Import fehlgeschlagen!
      </div>}
      {(importstate === "loading") ?
        <Spinner animation='grow' /> :
        <button type="button" className="btn btn-primary" onClick={() => postIMVData(imvdata, selecteduser)}>Kontakte zu oO importieren</button>}



    </div>
  )
}

export default IMVImport
